/**
 * ARQUIVO QUE ABRE NO EXCEL BRASILEIRO — e só isso.
 *
 * Existe porque o romaneio viaja: ele sai da fazenda e chega no computador do
 * comprador ou do contador, e lá ninguém vai instalar nada para abri-lo.
 *
 * Duas exigências, e as duas são do Excel em português, não do CSV:
 *
 *   SEPARADOR É PONTO E VÍRGULA. O Excel configurado em pt-BR lê vírgula como
 *   decimal, então um CSV separado por vírgula chega com tudo numa coluna só.
 *
 *   O ARQUIVO COMEÇA COM BOM. Sem ele o Excel abre em Latin-1 e «matrinchã»
 *   vira «matrinchÃ£» — num papel que representa a fazenda diante de quem
 *   compra.
 *
 * Números saem em pt-BR, com vírgula decimal: é o padrão do sistema, e é o que
 * o Excel do outro lado espera como número, não como texto.
 */

/** Um campo: aspas duplicadas e o campo inteiro entre aspas se precisar. */
function celula(valor: string | number | null): string {
  if (valor === null) return ''
  const texto =
    typeof valor === 'number' ? valor.toLocaleString('pt-BR', { maximumFractionDigits: 3 }) : valor
  return /[";\n\r]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto
}

export function montarCsv(linhas: (string | number | null)[][]): string {
  // \r\n porque é o que o Excel espera; \n sozinho ele às vezes junta linhas.
  return linhas.map((l) => l.map(celula).join(';')).join('\r\n')
}

/**
 * Entrega o arquivo ao aparelho. Funciona sem sinal: o conteúdo já está aqui.
 *
 * Devolve `false` quando o navegador não deixa baixar — em vez de falhar
 * calado, para a tela poder oferecer a impressão, que é o outro caminho.
 */
export function baixarCsv(nomeDoArquivo: string, linhas: (string | number | null)[][]): boolean {
  try {
    const conteudo = `﻿${montarCsv(linhas)}`
    const url = URL.createObjectURL(new Blob([conteudo], { type: 'text/csv;charset=utf-8' }))
    const a = document.createElement('a')
    a.href = url
    a.download = nomeDoArquivo.endsWith('.csv') ? nomeDoArquivo : `${nomeDoArquivo}.csv`
    document.body.appendChild(a)
    a.click()
    a.remove()
    // Um instante para o navegador começar a ler antes de soltar a memória.
    setTimeout(() => URL.revokeObjectURL(url), 10_000)
    return true
  } catch {
    return false
  }
}

/** «2026-09-20» e «T4-2601» viram «romaneio-T4-2601-2026-09-20». */
export function nomeDeArquivo(prefixo: string, ...partes: string[]): string {
  return [prefixo, ...partes]
    .join('-')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^\w-]/g, '-')
    .replace(/-+/g, '-')
}
